import React from 'react';
import { default as AdvisorConfirmationPageAnon } from "./AdvisorConfirmationAnon";
import { Content } from "./Content";
import { Layout } from "../../../../components/StudentOnboarding/Layout";
import { useAppContext } from "../../../CEF/Providers";
var AdvisorConfirmationPageStudent = function AdvisorConfirmationPageStudent() {
  function handleOnClick() {
    window.location.assign("".concat(window.location.origin, "/partners"));
  }
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Content, {
    handleOnClick: handleOnClick
  }));
};
export var AdvisorConfirmationPage = function AdvisorConfirmationPage() {
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  return userId ? /*#__PURE__*/React.createElement(AdvisorConfirmationPageStudent, null) : /*#__PURE__*/React.createElement(AdvisorConfirmationPageAnon, null);
};